<template>
  <div
    v-swiper="swiperOptions"
    class="footer-protection swiper"
  >
    <ul
      class="footer-protection__list swiper-wrapper"
    >
      <li
        v-for="item in $options.static.iconsProtection"
        :key="item.src"
        class="footer-protection__item swiper-slide"
      >
        <Component
          :is="item.attr.href ? 'a' : 'div'"
          v-bind="item.attr"
          class="footer-protection__link"
        >
          <img
            :src="`/img/footer/protection/${item.src}`"
            class="footer-protection__image"
            :alt="item.name"
          />
        </Component>
      </li>
    </ul>
  </div>
</template>

<script>
const swiperOptions = {
  slidesPerView: 'auto',
  freeMode: true,
  preventClicks: true,
  preventClicksPropagation: false,
  threshold: 12,
}

export default {
  name: 'FooterProtection' ,
  data() {
    return {
      swiperOptions: swiperOptions,
    }
  },
  head() {
    return {
      script: [
        {
          src: 'https://images.dmca.com/Badges/DMCABadgeHelper.min.js',
          body: true,
          async: true,
        },
      ],
    }
  },
  static: {
    iconsProtection: [
      {
        src: 'ssl.svg',
        attr: {},
        name: 'ssl',
      },
      {
        src: 'gamcare.svg',
        attr: {
          href: 'https://www.gamcare.org.uk/',
          target: '_blank',
          rel: 'noindex nofollow',
        },
        name: 'gamcare',
      },
      {
        src: 'be-gamble-aware.svg',
        attr: {
          href: 'https://www.gambleaware.org/',
          target: '_blank',
          rel: 'noindex nofollow',
        },
        name: 'be gamble aware',
      },
      {
        src: 'gambling-therapy.svg',
        attr: {
          href: 'https://www.gamblingtherapy.org/',
          target: '_blank',
          rel: 'noindex nofollow',
        },
        name: 'gambling therapy',
      },
      {
        src: 'dmca.webp',
        attr: {
          href: 'https://www.dmca.com/Protection/Status.aspx?ID=8e79e906-348c-4f7c-874a-b2c1a179b348&refurl=https://beton.ua/',
          target: '_blank',
          rel: 'noindex nofollow',
          class: 'dmca-badge',
        },
        name: 'dmca',
      },
      {
        src: '21+.svg',
        attr: {},
        name: '21 years old plus',
      },
      {
        src: 'pci.svg',
        attr: {},
        name: 'pci security standards council',
      },
    ],
  },
}
</script>

<style lang="scss" scoped src="./style.scss"></style>
